import {Theme, createStyles} from '@material-ui/core';

import {getBlockTitleStyles} from 'src/Components/Home/getBlockTitleStyles';

export const expectationsStyles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			paddingTop: theme.spacing(14),
			paddingBottom: theme.spacing(14),
			[theme.breakpoints.down('sm')]: {
				paddingTop: theme.spacing(2),
				paddingBottom: theme.spacing(7),
				backgroundColor: theme.palette.common.white,
			},
		},
		arrowWrapper: {
			'&::before': {
				display: 'block',
				content: '" "',
				backgroundColor: theme.palette.primary.main,
				height: theme.spacing(10),
				width: theme.spacing(0.25),
				position: 'relative',
				left: '50%',
				transform: 'translateX(-50%)',
			},
		},
		arrow: {
			marginTop: theme.spacing(-1),
			color: theme.palette.primary.main,
			marginBottom: theme.spacing(6.5),
			[theme.breakpoints.down('sm')]: {
				marginBottom: theme.spacing(4),
			},
		},
		why: {
			...getBlockTitleStyles(theme),
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(26),
			[theme.breakpoints.down('sm')]: {
				fontSize: theme.typography.pxToRem(14),
			},
		},
		percent: {
			...getBlockTitleStyles(theme),
			fontSize: theme.typography.pxToRem(120),
			color: theme.palette.primary.main,
			lineHeight: '100%',
			paddingBottom: theme.spacing(1.5),
			[theme.breakpoints.down('sm')]: {
				fontSize: theme.typography.pxToRem(50),
			},
		},
		expectations: {
			...getBlockTitleStyles(theme),
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(26),
			whiteSpace: 'pre-line',
			textAlign: 'center',
			[theme.breakpoints.down('sm')]: {
				fontSize: theme.typography.pxToRem(14),
				lineHeight: theme.typography.pxToRem(22),
			},
		},
	});
